import { toast } from 'sonner';
import { useFeedbackMutation, useSupportMutation } from '../../services/api';

// Custom hook for handling Support functionality
const useSupportHandler = () => {
  const [_FEEDBACK, { isLoading: feedbackLoading }] = useFeedbackMutation();
  const [_SUPPORT, { isLoading: supportLoading }] = useSupportMutation();

  // Function to handle the feedback process
  const feedbackHandler = async (values, setIsDrawerOpen) => {
    try {
      const response = await _FEEDBACK(values);

      if (response?.data?.success) {
        toast.success('Thank you for your feedback');
      }

      if (response?.error) {
        // Handle and display the error message if unsuccessful
        toast.error(response?.error?.data?.errorObject?.userErrorText);
      }
      setIsDrawerOpen(false);
    } catch (error) {
      // Handle unexpected errors and log them
      console.error('feedback error:', error);
    }
  };

  // Function to handle the feedback process
  const supportHandler = async (values, setIsDrawerOpen) => {
    try {
      const response = await _SUPPORT(values);

      if (response?.data?.success) {
        toast.success('Our Support Team will get back to you soon');
      }

      if (response?.error) {
        // Handle and display the error message if unsuccessful
        toast.error(response?.error?.data?.errorObject?.userErrorText);
      }
      setIsDrawerOpen(false);
    } catch (error) {
      // Handle unexpected errors and log them
      console.error('support error:', error);
    }
  };

  return {
    isLoading: feedbackLoading || supportLoading,
    feedbackHandler,
    supportHandler,
  };
};

export default useSupportHandler;
